import React from "react";

export const ACTION_STATE_ERROR = "error";
export const ACTION_STATE_LOADING = "loading";
export const ACTION_STATE_SUCCESS = "success";
export const API_RESPONSE_MESSAGE_ERROR = "Error";
export const FORM_FEEDBACK_SR_PREFIX = (<span className="sr-only">Form Error: </span>);
export const STUDENT_STATUS_CURRENT = "ENROLLED";
export const STUDENT_STATUS_NEW_ADMIT = "NEWADMIT";